import React from 'react'
import PropTypes from 'prop-types'

import Tooltip from 'Pods/Shared/Tooltip'
import Icon from 'Pods/Shared/Icon/Icon'

import BatchDraftEditorModal from '../BatchDraftEditor/BatchDraftEditorModal'

class BatchDraftEditorButton extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      modalIsOpen: false,
    }

    this.openModal = this.openModal.bind(this)
    this.closeModal = this.closeModal.bind(this)
  }

  openModal() {
    const collections = this.props.selectedItems.filter(item => item.type === 'collections')
    const notDraftModels = this.props.selectedItems.filter(item => item.attributes.status !== 'draft' && item.type === 'models')

    if (collections.length > 0 || notDraftModels.length > 0) {
      if (collections.length > 0) {
        App.events.publish('app:notification:flash:error', 'You cannot apply templates to packs.')
      }

      if (notDraftModels.length > 0) {
        App.events.publish('app:notification:flash:error', 'Please select only models with draft status.')
      }

      return null
    }

    this.setState({ modalIsOpen: true })
  }

  closeModal() {
    this.setState({ modalIsOpen: false })
  }

  render() {
    const tooltipText = 'Apply details like Description, Tags, Technical information to multiple model drafts at once!'

    return (
      <div className="u-inline-block u-mr10">
        <Tooltip
          tooltipClassName="tooltip--medium u-text-center"
          className="u-block"
          id="apply-template-btn-tooltip"
          content={tooltipText}
        >
          <button className="btn btn-outline-default btn-white" onClick={this.openModal} disabled={this.props.isDisabled}>
            <Icon type={['fas', 'pen']} />
            <span>Apply template</span>
          </button>
        </Tooltip>

        {this.state.modalIsOpen && (
          <BatchDraftEditorModal
            modalIsOpen={this.state.modalIsOpen}
            closeModal={this.closeModal}
            itemIds={this.props.selectedItems}
            clearSelection={this.props.clearSelection}
            cadProductTypeEnabled={this.props.cadProductTypeEnabled}
          />
        )}
      </div>
    )
  }
}

BatchDraftEditorButton.propTypes = {
  selectedItems: PropTypes.array.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  clearSelection: PropTypes.func.isRequired,
  cadProductTypeEnabled: PropTypes.bool,
}

BatchDraftEditorButton.defaultProps = {
  cadProductTypeEnabled: false,
}

export default BatchDraftEditorButton
